module.exports = __webpack_public_path__ + "static/media/amberwarning.b3707753.png";